import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'Post Image'
export const group = 'Dynamic Post Template'
export const beta = false

export const defaultOptions = {
  content: {
    data: {
      type: 'post-image-mod'
    }
  }
}

export const icon = ''

export default class ElPostCategories extends SectionProvider {
  constructor (options = {}) {
    super('ElPostImage', options)

    this.name = name
    this.group = group
    this.defaultOptions = defaultOptions
  }
}
